<template>
  <div class="dynamic_detail">
    <el-breadcrumb class="crumb" separator=">">
      <el-breadcrumb-item :to="{ path: '/dynamic' }"><span class="pointer" style="color: #A9ADB0">定向动态</span></el-breadcrumb-item>
      <el-breadcrumb-item><span class="pointer" style="color: #76BF28">详情</span></el-breadcrumb-item>
    </el-breadcrumb>
    <div class="dynamic_detail_box">
      <h2>{{ detail.title }}</h2>
      <p class="dynamic_detail_time"><img src="@/assets/clock-icon.png" /><span>发布日期 {{ detail.createdAt | dateFormat }}</span></p>
      <div class="ql-editor" v-html="detail.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dynamicDetail',
  components: {},
  data () {
    return {
      detail: {}
    }
  },
  created () {
  },
  mounted () {
    this.loadDetail()
  },
  computed: {},
  methods: {
    loadDetail () {
      this.$axios.detail(this.$route.query.itemId).then(res => {
        if (res) {
          this.detail = res.data.data
        }
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
  .dynamic_detail .crumb { margin-bottom: 20px; }
  .dynamic_detail .dynamic_detail_box { padding: 50px; border:1px solid #DCDFE6; }
  .dynamic_detail .dynamic_detail_box h2 { font-size: 32px; font-weight: 600; color: #333333; line-height: 25px; margin-bottom: 20px; text-align: center; }
  .dynamic_detail .dynamic_detail_box .dynamic_detail_time { margin-bottom: 30px; text-align: center; }
  .dynamic_detail .dynamic_detail_box .dynamic_detail_time img { width: 12px; height: 12px; margin-right: 5px; }
  .dynamic_detail .dynamic_detail_box .dynamic_detail_time span { font-size: 12px; font-weight: 400; color: #999999; line-height: 12px; }
</style>



// WEBPACK FOOTER //
// src/pages/dynamic/detail/detail.vue